import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import errorToast from "../../../../helper-components/error-toast";

import LoadingSpinner from "../../../../helper-components/loading-spinner";
import { Field, Form, Formik } from "formik";

import AddButton from "../../../../buttons/button";
import DeleteIcon from "../../../../../assets/icons/delete-icon";

import successToast from "../../../../helper-components/success-toast";
import {
  leadCreateAction,
  leadDeleteAction,
  leadEditAction,
  leadSearchListAction,
  paymentCreateAction,
  paymentDeleteAction,
  paymentEditAction,
  paymentSearchListAction,
} from "../../../../../redux/actions/settings-action";
import TableContent from "../helper/table-content";

function PaymentComp({ pageLoading, setPageLoading, searchValue ,setReload,reload }) {
  const [initialData, setItemTypeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [debouncedSearchValue, setDebouncedSearchValue] = useState("");

  const tableHeading = ["Term Code", "Term Name", "Description", "Actions"];
  const initialValues = {
    data: initialData,
    newLine: {
      code: "",
      name: "",
      discription: "",
    },
  };
  const dispatch = useDispatch();

  const onSuccess = (data) => {
    setItemTypeData(data?.data?.list);
    setLoading(false);
    console.log("drugs loaded successfully", data.data);
  };

  const onSaveSuccess = (data) => {
    fetchData();
    setLoading(false);
    successToast(data?.message);
  };

  const onSaveError = (data) => {
    fetchData();
    setLoading(false);
    errorToast(data?.data?.message);
  };

  const onError = (data) => {
    setLoading(false);
    errorToast(data?.data?.message);
  };

  const fetchData = (searchValue = "") => {
    if (loading) {
      return;
    }

    setLoading(true);
    dispatch(paymentSearchListAction(searchValue, onSuccess, onError));
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, 800);

    return () => clearTimeout(timer);
  }, [searchValue]);

  useEffect(() => {
    if (debouncedSearchValue !== "" || searchValue === "") {
      fetchData(debouncedSearchValue);
    }
  }, [debouncedSearchValue]);

  const onSubmit = (values) => {
    console.log("clicked");
    if (!loading) {
      const changedObjects = [];
      let newLineObject = null;

      initialData?.forEach((item, index) => {
        if (JSON.stringify(values.data[index]) !== JSON.stringify(item)) {
          changedObjects.push(values.data[index]);
        } else return;
      });

      if (
        JSON.stringify(values.newLine) !== JSON.stringify(initialValues.newLine)
      ) {
        if (values.newLine.code === "" || values.newLine.name === "") {
          errorToast("Payment Code and Name are required");
        } else newLineObject = values.newLine;
      }

      if (newLineObject !== null) {
        setLoading(true);
        console.log("create --", newLineObject);
        dispatch(
          paymentCreateAction(newLineObject, onSaveSuccess, onSaveError)
        );
      }

      if (changedObjects.length > 0) {
        setLoading(true);
        let cleanData = [...changedObjects];
        cleanData.forEach((item, _) => {
          delete item?.created_date;
          delete item?.update_date;
        });
        dispatch(paymentEditAction(cleanData, onSaveSuccess, onSaveError));
      }
    }
  };

  const onClickDelete = (roleId) => {
    if (!loading) {
      setLoading(true);
      dispatch(paymentDeleteAction({ id: roleId }, onSaveSuccess, onSaveError));
    }
  };
 useEffect(() => {
    if (reload) {
      fetchData();
      setReload(false);
    }
  }, [reload]);
  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      {({ values, setFieldValue, handleSubmit }) => (
        <Form className="pt-1">
          <div
            className="flex flex-col justify-between rounded-xl"
            style={{ height: "74vh" }}
          >
            {loading ? (
              <LoadingSpinner />
            ) : (
              <TableContent
                values={values}
                tableHeading={tableHeading}
                onClickDelete={onClickDelete}
              />
            )}
            <div className="mt-auto flex gap-3 items-center justify-end w-full h-[4rem]">
              <AddButton
                onclkFn={handleSubmit}
                prefixIcon={false}
                text="Save"
                type="submit"
                className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)] 
    font-[var(--primary-button-font-weight)]
    "
              />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default PaymentComp;
